import Tooltips from './Tooltips';

export default {
  __init__: [ 'tooltips' ],
  tooltips: [ 'type', Tooltips ]
};